<template>
    <a-config-provider :autoInsertSpaceInButton="false" :locale="locale">
        <div class="notification">
            <a-breadcrumb separator=">">
                <a-breadcrumb-item>
                    <router-link to="/home">
                        <img src="../../assets/home/icon-home.svg" style="margin: 0 4px 4px 0" />首页
                    </router-link>
                </a-breadcrumb-item>
                <a-breadcrumb-item>{{ propActive }}</a-breadcrumb-item>
            </a-breadcrumb>

            <div class="notification-body">
                <submenu-tabs
                    haveSubtitle
                    :prop-active="propActive"
                    :title="mainTitle"
                    :tabs="leftTab"
                    @changeTab="tabChanged"
                />
                <div class="right-content">
                    <div class="subtitle">{{ propActive }}</div>
                    <div class="container" v-if="isList">
                        <a-spin :spinning="loading">
                            <div class="notify-list">
                                <div class="list-item" v-for="item in noList" :key="item.id">
                                    <div class="title" @click="viewDetail(item)">{{ item.title }}</div>
                                    <div class="date">{{ item.publishDate }}</div>
                                </div>
                            </div>
                        </a-spin>
                        <a-pagination
                            class="sw-pagination"
                            v-model="current"
                            :defaultPageSize="pageSize"
                            :pageSizeOptions="pageSizeOptions"
                            :total="total"
                            show-quick-jumper
                            show-size-changer
                            @showSizeChange="onChange"
                            @change="onChange"
                        />
                    </div>

                    <!-- 办事指南 -->
                    <div class="container" v-if="!isList && parentCode != 'notice'">
                        <div v-html="content" v-if="content"></div>
                        <div class="files" v-if="fileList.length">
                            <div>附件：</div>
                            <div class="list-item" v-for="(item, i) in fileList" :key="item.id">
                                <span>{{ i + 1 }}、</span>
                                <div class="title" @click="downloadFile(item)">{{ item.name }}</div>
                            </div>
                        </div>
                        <a-empty v-if="!content && !fileList.length" />
                        <div class="back">
                            <a-button @click="isList = true" class="back" size="small">返回</a-button>
                        </div>
                    </div>

                    <!-- 通知公告 -->
                    <div class="container" v-if="!isList && parentCode == 'notice'">
                        <div v-html="content"></div>
                        <div class="files" v-if="fileList.length">
                            <div>附件：</div>
                            <div class="list-item" v-for="(item, i) in fileList" :key="item.id">
                                <span>{{ i + 1 }}、</span>
                                <div class="title" @click="downloadFile(item)">{{ item.name }}</div>
                            </div>
                        </div>
                        <a-empty v-if="!content && !fileList.length" />
                        <div class="back">
                            <a-button @click="isList = true" class="back" size="small">返回</a-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-config-provider>
</template>

<script>
import { getNotifyTypeList, queryType, getNoticeData, queryGuideList, queryGuideDetail } from '../../common/api';
import submenuTabs from '../../components/submenu-tabs.vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import axios from 'axios';

export default {
    components: {
        submenuTabs
    },

    data() {
        return {
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            current: 1,
            pageSize: 10,
            total: 50,
            locale: zhCN,
            mainTitle: '通知公告',
            propActive: '',
            currentTypeCode: '',
            leftTab: [
                {
                    name: '通知公告',
                    id: 1,
                    code: 'notice',
                    children: []
                },
                {
                    name: '办事指南',
                    id: 2,
                    children: []
                }
                // {
                //     name: '法规公告',
                //     id: 2,
                //     children: [{ title: '法律法规', id: 21 }]
                // }
            ],
            isList: true,
            loading: true,
            contentDetail: '',
            noList: [],
            contentType: '', //0--富文本  1--文件列表
            fileList: [],
            parentCode: ''
        };
    },

    computed: {
        content() {
            return this.contentDetail || '';
        }
    },

    mounted() {
        this.getTypeList();
        this.mainTitle = '通知公告';
        this.propActive = '通知公告';
        this.currentTypeCode = 'notice';
        this.parentCode = 'notice';

        if (this.$route.query.code === 'handleGuide') {
            this.mainTitle = '办事指南';
            this.propActive = '办事指南';
            this.currentTypeCode = '';
            this.parentCode = '';
        }

        if (this.parentCode === 'notice') {
            this.getNoticeList();
        } else {
            this.getNotifyList();
        }
    },

    methods: {
        async getTypeList() {
            const { data } = await getNotifyTypeList();
            const res = await queryType();
            this.leftTab[0].children = res.data.map(t => {
                return {
                    ...t,
                    name: t.codename,
                    parentCode: 'notice'
                };
            });
            this.leftTab[1].children = data.map(t => {
                return {
                    ...t,
                    name: t.codename,
                    parentCode: ''
                };
            });
        },

        async getNotifyList() {
            this.loading = true;
            const { data } = await queryGuideList({
                n: this.current,
                s: this.pageSize,
                f: this.currentTypeCode ? { guideType_SEQ: this.currentTypeCode } : {}
            });
            this.total = data.total;
            this.noList = data.rows.map(item => {
                return {
                    ...item,
                    title: item.shortName
                };
            });
            this.loading = false;
        },

        async getNoticeList() {
            this.loading = true;
            const { data } = await getNoticeData({
                n: this.current,
                s: this.pageSize,
                f: { infoCategory_SEQ: this.currentTypeCode, status_SEQ: 'normal' }
            });
            this.total = data.total;
            this.noList = data.rows;
            this.loading = false;
        },

        async downloadFile(file) {
            this.downloadByBlob(file.downloadUrl, file.name);
        },

        downloadByBlob(url, fileName) {
            const pathArr = url?.split('/') ?? [];
            axios.get(url, { responseType: 'blob' }).then(res => {
                const blob = new Blob([res.data]);
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = fileName || pathArr[pathArr.length - 1] || true;
                link.click();
                URL.revokeObjectURL(link.href);
            });
        },

        async viewDetail(item) {
            this.contentDetail = '';
            this.fileList = [];
            //通知公告
            if (this.parentCode === 'notice') {
                const { data } = await getNoticeData({
                    n: 1,
                    s: 10,
                    f: { id_EQ: item.id }
                });
                this.contentDetail = data.rows[0].content;
                this.fileList = JSON.parse(data.rows[0].attachment);
            } else {
                //办事指南
                const { data } = await queryGuideDetail(item.id);
                if (data.contentType === '0') {
                    this.contentDetail = data.contentList[0]?.content ?? '';
                } else {
                    this.fileList = data.contentList.map(item => {
                        return {
                            ...item,
                            name: item.content
                        };
                    });
                }
            }
            this.isList = false;
        },

        tabChanged(tab) {
            this.propActive = tab.name;
            this.currentTypeCode = tab.code;
            this.parentCode = tab.parentCode || '';
            if (this.parentCode === 'notice') {
                this.mainTitle = '通知公告';
                this.getNoticeList();
            } else {
                this.mainTitle = '办事指南';
                this.getNotifyList();
            }
            this.isList = true;
        },

        onChange(page, size) {
            this.current = page;
            this.pageSize = size;
            if (this.parentCode === 'notice') {
                this.getNoticeList();
            } else {
                this.getNotifyList();
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.notification {
    width: 1200px;
    padding-bottom: 78px;

    &-body {
        display: flex;
        align-items: flex-start;

        ::v-deep {
            .submenu-tabs {
                flex-shrink: 0;
                .tabs {
                    padding: 24px 8px;
                }
                .tabs.isSub .tab-item {
                    // &:nth-child(1) {
                    //     position: relative;
                    //     font-size: 16px;
                    //     color: #333333;
                    //     padding: 13px 32px 13px 42px;
                    //     color: #333;
                    //     cursor: pointer;
                    // }
                    &.active {
                        background: #005299;
                        font-weight: 600;
                        color: #fff;
                    }
                }
            }
        }

        .right-content {
            flex-grow: 1;
            margin-left: 16px;
            background: #ffffff;
            border-radius: 4px;
            padding: 16px 24px;

            .subtitle {
                height: 48px;
                font-size: 24px;
                font-weight: 600;
                letter-spacing: 0;
                color: #005299;
                background: url(../../assets/test-service/split.png) bottom no-repeat;
            }

            .container {
                padding: 16px 0;
                font-size: 16px;

                > .ant-btn {
                    margin: 12px 0;
                }

                .files {
                    margin-top: 50px;
                    font-size: 14px;

                    .list-item {
                        display: flex;
                        align-items: center;
                        height: 30px;
                        line-height: 30px;
                        .title {
                            color: #007fff;
                            cursor: pointer;
                        }
                    }
                }
            }

            .notify-list {
                margin-bottom: 16px;
                border-bottom: 1px solid #d9d9d9;

                .list-item {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 40px;
                    line-height: 40px;
                    font-size: 16px;

                    .title {
                        color: #333333;
                        cursor: pointer;
                    }
                    .date {
                        color: #666666;
                    }
                }
            }

            .ant-pagination {
                display: flex;
                justify-content: flex-end;
            }

            .back {
                width: 60px;
                margin: 16px auto 0 auto;
            }
        }
    }
}
</style>
